export default __webpack_public_path__ + "static/media/ima300.9feb025e.jpg";